import React, { useState } from "react";
import Layout from "../../../components/Layout/Layout";
import {
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  Divider,
  IconButton,
  Chip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { BackIcon } from "../../../components/icons/BackIcon";
const CompanyInformation = (props) => {
  const [isEditing, setIsEditing] = useState(false);
  const [contactInfo, setContactInfo] = useState({
    sociedad: "correo@ejemplo.com",
    representante: "123-456-7890",
    datosFiscales: {
      calle: "Calle Falsa 123",
      regimen: "",
      telefono: "",
      ciudad: "",
      calle: "",
      numero_int: 0,
      numero_ext: 0,
      colonia: "",
    },
  });

  const [editInfo, setEditInfo] = useState({ ...contactInfo });

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    setContactInfo(editInfo);
    setIsEditing(false);
  };

  const handleChange = (e) => {
    setEditInfo({
      ...editInfo,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <Layout>
      <Grid item xs={2} sx={{ display: "flex", justifyContent: "end" }}>
        <IconButton aria-label='' onClick={() => props.history.goBack()}>
          <BackIcon />
        </IconButton>
      </Grid>
      <Grid
        container
        spacing={2}
        sx={{ justifyContent: "center", marginTop: 5 }}
      >
        <Grid item xs={12} sm={9} md={9} lg={9} xl={9}>
          <Paper elevation={3} sx={{ padding: 2, marginBottom: 4 }}>
            <Typography variant='h4' gutterBottom>
              Administra Información de la sociedad
            </Typography>
            <Grid
              item
              xs={12}
              sm={9}
              md={9}
              lg={9}
              xl={9}
              sx={{ justifyContent: "center" }}
            >
              {isEditing ? (
                <div>
                  <TextField
                    label='Sociedad'
                    name='name'
                    value={editInfo.name}
                    onChange={handleChange}
                    fullWidth
                    margin='normal'
                  />
                  <TextField
                    label='Representante Legal'
                    name='legal_name'
                    value={editInfo.email}
                    onChange={handleChange}
                    fullWidth
                    margin='normal'
                  />
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    display='flex'
                    justifyContent='center'
                  >
                    <Divider />
                    <Chip label='Datos Fiscales' />
                    <Divider />
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        label='RFC'
                        name='phone'
                        value={editInfo.phone}
                        onChange={handleChange}
                        fullWidth
                        margin='normal'
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        label='Regimen Fiscal'
                        name='phone'
                        value={editInfo.phone}
                        onChange={handleChange}
                        fullWidth
                        margin='normal'
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        label='Dirección'
                        name='phone'
                        value={editInfo.phone}
                        onChange={handleChange}
                        fullWidth
                        margin='normal'
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        label='Calle'
                        name='address'
                        value={editInfo.address}
                        onChange={handleChange}
                        fullWidth
                        margin='normal'
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        label='Codigo Postal'
                        name='typeUser'
                        value={editInfo.typeUser}
                        onChange={handleChange}
                        fullWidth
                        margin='normal'
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        label='Numero Int'
                        name='extras'
                        value={editInfo.extras}
                        onChange={handleChange}
                        fullWidth
                        margin='normal'
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        label='Numero Ext'
                        name='extras'
                        value={editInfo.extras}
                        onChange={handleChange}
                        fullWidth
                        margin='normal'
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        label='Colonia'
                        name='extras'
                        value={editInfo.extras}
                        onChange={handleChange}
                        fullWidth
                        margin='normal'
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        label='Ciudad'
                        name='extras'
                        value={editInfo.extras}
                        onChange={handleChange}
                        fullWidth
                        margin='normal'
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        label='Estado'
                        name='extras'
                        value={editInfo.extras}
                        onChange={handleChange}
                        fullWidth
                        margin='normal'
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        label='Municipio'
                        name='extras'
                        value={editInfo.extras}
                        onChange={handleChange}
                        fullWidth
                        margin='normal'
                      />
                    </Grid>
                  </Grid>

                  <Button
                    variant='contained'
                    color='primary'
                    onClick={handleSaveClick}
                  >
                    Guardar
                  </Button>
                </div>
              ) : (
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Typography variant='body1'>
                        <svg
                          version='1.0'
                          id='Layer_1'
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 64 64'
                          enable-background='new 0 0 64 64'
                          fill='#000000'
                          width='45px'
                        >
                          <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                          <g
                            id='SVGRepo_tracerCarrier'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></g>
                          <g id='SVGRepo_iconCarrier'>
                            {" "}
                            <g>
                              {" "}
                              <g>
                                {" "}
                                <path
                                  fill='#F76D57'
                                  d='M43,2v22c0,2.209,1.791,4,4,4s4-1.791,4-4V2H43z'
                                ></path>{" "}
                                <path
                                  fill='#F76D57'
                                  d='M23,24c0,2.209,1.791,4,4,4s4-1.791,4-4V2h-8V24z'
                                ></path>{" "}
                                <path
                                  fill='#F76D57'
                                  d='M3,4v20c0,2.209,1.791,4,4,4s4-1.791,4-4V2H5C3.896,2,3,2.895,3,4z'
                                ></path>{" "}
                              </g>{" "}
                              <path
                                fill='#F9EBB2'
                                d='M58,60c0,1.104-0.896,2-2,2H26V37c0-0.516-0.447-1-1-1H11c-0.553,0-1,0.447-1,1v25H8c-1.104,0-2-0.896-2-2 V29.91C6.326,29.965,6.658,30,7,30c2.088,0,3.926-1.068,5-2.688C13.074,28.932,14.912,30,17,30s3.926-1.068,5-2.688 C23.074,28.932,24.912,30,27,30s3.926-1.068,5-2.688C33.074,28.932,34.912,30,37,30s3.926-1.068,5-2.688 C43.074,28.932,44.912,30,47,30s3.926-1.068,5-2.688C53.074,28.932,54.912,30,57,30c0.342,0,0.674-0.035,1-0.09V60z'
                              ></path>{" "}
                              <g>
                                {" "}
                                <path
                                  fill='#B4CCB9'
                                  d='M33,24c0,2.209,1.791,4,4,4s4-1.791,4-4V2h-8V24z'
                                ></path>{" "}
                                <path
                                  fill='#B4CCB9'
                                  d='M13,24c0,2.209,1.791,4,4,4s4-1.791,4-4V2h-8V24z'
                                ></path>{" "}
                                <path
                                  fill='#B4CCB9'
                                  d='M59,2h-6v22c0,2.209,1.791,4,4,4s4-1.791,4-4V4C61,2.895,60.104,2,59,2z'
                                ></path>{" "}
                              </g>{" "}
                              <path
                                fill='#394240'
                                d='M59,0H5C2.789,0,1,1.789,1,4v20c0,2.219,1.208,4.152,3,5.189V60c0,2.211,1.789,4,4,4h48 c2.211,0,4-1.789,4-4V29.189c1.792-1.037,3-2.971,3-5.189V4C63,1.789,61.211,0,59,0z M51,2v22c0,2.209-1.791,4-4,4s-4-1.791-4-4V2 H51z M41,2v22c0,2.209-1.791,4-4,4s-4-1.791-4-4V2H41z M31,2v22c0,2.209-1.791,4-4,4s-4-1.791-4-4V2H31z M21,2v22 c0,2.209-1.791,4-4,4s-4-1.791-4-4V2H21z M3,4c0-1.105,0.896-2,2-2h6v22c0,2.209-1.791,4-4,4s-4-1.791-4-4V4z M12,62V38h12v10h-1 c-0.553,0-1,0.447-1,1s0.447,1,1,1h1v12H12z M58,60c0,1.104-0.896,2-2,2H26V37c0-0.516-0.447-1-1-1H11c-0.553,0-1,0.447-1,1v25H8 c-1.104,0-2-0.896-2-2V29.91C6.326,29.965,6.658,30,7,30c2.088,0,3.926-1.068,5-2.688C13.074,28.932,14.912,30,17,30 s3.926-1.068,5-2.688C23.074,28.932,24.912,30,27,30s3.926-1.068,5-2.688C33.074,28.932,34.912,30,37,30s3.926-1.068,5-2.688 C43.074,28.932,44.912,30,47,30s3.926-1.068,5-2.688C53.074,28.932,54.912,30,57,30c0.342,0,0.674-0.035,1-0.09V60z M57,28 c-2.209,0-4-1.791-4-4V2h6c1.104,0,2,0.895,2,2v20C61,26.209,59.209,28,57,28z'
                              ></path>{" "}
                              <path
                                fill='#394240'
                                d='M53,36H29c-0.553,0-1,0.447-1,1v20c0,0.553,0.447,1,1,1h24c0.553,0,1-0.447,1-1V37 C54,36.447,53.553,36,53,36z M52,56H30V38h22V56z'
                              ></path>{" "}
                              <g>
                                {" "}
                                <path
                                  fill='#45AAB8'
                                  d='M12,62h12V50h-1c-0.553,0-1-0.447-1-1s0.447-1,1-1h1V38H12V62z'
                                ></path>{" "}
                                <rect
                                  x='30'
                                  y='38'
                                  fill='#45AAB8'
                                  width='22'
                                  height='18'
                                ></rect>{" "}
                              </g>{" "}
                              <path
                                fill='#394240'
                                d='M48.293,42.707C48.488,42.902,48.744,43,49,43s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414 l-1-1c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L48.293,42.707z'
                              ></path>{" "}
                              <path
                                fill='#394240'
                                d='M48.293,47.707C48.488,47.902,48.744,48,49,48s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414 l-6-6c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L48.293,47.707z'
                              ></path>{" "}
                            </g>{" "}
                          </g>
                        </svg>
                        <p
                          style={{
                            marginLeft: 60,
                            marginTop: -60,
                            fontWeight: "bold",
                            fontSize: "25px",
                          }}
                        >
                          Sociedad
                        </p>
                        <p style={{ marginLeft: 65 }}>
                          Infinity B3 Center Comercial{" "}
                          <CheckCircleIcon sx={{ color: "green" }} />
                        </p>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Typography variant='body1'>
                        <svg
                          width='45px'
                          version='1.1'
                          id='Layer_1'
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 512.001 512.001'
                          fill='#000000'
                        >
                          <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                          <g
                            id='SVGRepo_tracerCarrier'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></g>
                          <g id='SVGRepo_iconCarrier'>
                            {" "}
                            <g>
                              {" "}
                              <path
                                style={{ fill: "#ED8C18" }}
                                d='M256.001,120.203c10.407,0,55.992-1.303,73.575-11.454c0,0,17.092,40.216,29.657,50.96 c3.957-21.81,8.013-50.248,2.763-67.826c-15.405-51.577-57.613-81.21-105.992-81.215c-48.381,0-90.587,29.64-105.995,81.215 c-5.409,18.108-0.94,47.74,3.122,69.778c12.563-10.742,29.296-52.912,29.296-52.912 C200.008,118.901,245.591,120.203,256.001,120.203z'
                              ></path>{" "}
                              <path
                                style={{ fill: "#FCD051" }}
                                d='M329.576,108.748c-17.582,10.152-63.167,11.454-73.575,11.454c-10.41,0-55.994-1.302-73.576-11.454 c0,0-16.733,42.17-29.296,52.912c1.589,8.623,3.115,16.081,3.963,21.233c9.764,59.294,17.468,55.78,49.101,77.237 c32.975,19.038,66.576,19.073,99.617-0.004c31.631-21.454,39.338-17.938,49.097-77.232c0.912-5.539,2.606-13.741,4.324-23.186 C346.67,148.966,329.576,108.748,329.576,108.748z'
                              ></path>{" "}
                              <g>
                                {" "}
                                <path
                                  style={{ fill: "#657694" }}
                                  d='M201.388,338.357l-19.374-57.821C61.912,326.595,46.589,353.293,10.669,501.329l93.549,0.002 l151.781-0.002l-30.08-89.767L201.388,338.357z'
                                ></path>{" "}
                                <path
                                  style={{ fill: "#657694" }}
                                  d='M310.612,338.357l-24.529,73.204l-30.082,89.769h56.54l29.856-50.358l29.856,50.358l35.528-0.002 h93.55c-35.921-148.036-51.242-174.733-171.345-220.792L310.612,338.357z'
                                ></path>{" "}
                              </g>{" "}
                              <g>
                                {" "}
                                <polygon
                                  style={{ fill: "#D12D4E" }}
                                  points='342.398,450.974 312.542,501.332 372.254,501.332 '
                                ></polygon>{" "}
                                <polygon
                                  style={{ fill: "#D12D4E" }}
                                  points='286.084,411.563 272.143,336.297 283.625,308.407 256.001,277.754 228.376,308.407 239.855,336.297 225.919,411.563 256.001,501.329 '
                                ></polygon>{" "}
                              </g>{" "}
                              <g>
                                {" "}
                                <polygon
                                  style={{ fill: "#ABB8B9" }}
                                  points='225.919,411.563 239.855,336.297 228.376,308.407 201.388,338.357 '
                                ></polygon>{" "}
                                <polygon
                                  style={{ fill: "#ABB8B9" }}
                                  points='272.143,336.297 286.084,411.563 310.612,338.357 283.625,308.407 '
                                ></polygon>{" "}
                                <path
                                  style={{ fill: "#ABB8B9" }}
                                  d='M201.388,338.357l26.988-29.95l27.627-30.653l27.623,30.653l26.988,29.95l19.374-57.821 l-15.649-21.511l-2.229-3.065c-1.987,1.285-4.084,2.666-6.296,4.165c-33.042,19.078-66.642,19.043-99.617,0.004 c-2.215-1.502-4.314-2.882-6.301-4.169l-3.001,4.123l-14.878,20.452L201.388,338.357z'
                                ></path>{" "}
                              </g>{" "}
                            </g>{" "}
                            <g>
                              {" "}
                              <path
                                style={{ fill: "#000003" }}
                                d='M104.216,427.497c5.892,0,10.667-4.776,10.667-10.667v-0.304c0-5.892-4.776-10.667-10.667-10.667 s-10.667,4.776-10.667,10.667v0.304C93.549,422.721,98.325,427.497,104.216,427.497z'
                              ></path>{" "}
                              <path
                                style={{ fill: "#000003" }}
                                d='M394.835,346.78l-0.232-0.161c-4.85-3.345-11.47-2.11-14.816,2.74 c-3.344,4.849-2.103,11.509,2.748,14.854l0.269,0.188c1.842,1.263,3.934,1.868,6.007,1.868c3.397,0,6.734-1.626,8.805-4.644 C400.951,356.768,399.692,350.114,394.835,346.78z'
                              ></path>{" "}
                              <path
                                style={{ fill: "#000003" }}
                                d='M511.698,498.814c-36.051-148.579-52.564-179.778-174.934-227.094l-9.376-12.888 c21.875-14.293,29.771-23.918,38.047-74.204c0.481-2.925,1.211-6.722,2.055-11.119c4.676-24.37,11.741-61.197,4.726-84.678 c-8.097-27.109-23.471-49.736-44.462-65.436C307.296,8.091,282.486,0.002,256.004,0c-26.482,0-51.292,8.088-71.753,23.392 c-20.99,15.701-36.365,38.329-44.462,65.436c-7.015,23.475,0.048,60.296,4.721,84.66c0.846,4.405,1.576,8.208,2.057,11.138 c8.281,50.284,16.175,59.912,38.047,74.204l-9.378,12.888C52.866,319.037,36.353,350.235,0.302,498.814 c-0.772,3.179-0.042,6.537,1.981,9.109s5.113,4.074,8.385,4.074l245.317,0.002c0.004,0,0.009,0,0.014,0c0,0,0.001,0,0.002,0 s0.002,0,0.002,0c0.005,0,0.01,0,0.014,0h56.484c0.011,0,0.021,0.002,0.031,0.002c0.013,0,0.022-0.002,0.033-0.002l188.768-0.001 c3.271,0,6.363-1.502,8.384-4.074C511.74,505.351,512.472,501.994,511.698,498.814z M213.482,340.871l11.479-12.737l3.834,9.314 l-5.859,31.635L213.482,340.871z M202.617,270.35c11.24,6.272,22.661,10.56,34.14,12.826l-31.06,34.467l-11.821-35.277 L202.617,270.35z M309.384,270.349l8.742,12.015l-11.822,35.277l-31.058-34.467C286.724,280.907,298.143,276.621,309.384,270.349z M249.721,332.237l-8.922-21.677l15.203-16.871l15.202,16.87l-8.925,21.677c-0.781,1.9-0.998,3.984-0.623,6.004l13.437,72.545 l-19.091,56.973l-19.088-56.967l13.434-72.55C250.719,336.22,250.502,334.136,249.721,332.237z M289.065,369.086l-5.861-31.637 l3.836-9.315l11.48,12.738L289.065,369.086z M160.231,94.936c13.562-45.399,50.26-73.601,95.771-73.601 c45.515,0.003,82.212,28.206,95.771,73.601c2.765,9.255,2.389,23.024,0.854,36.923c-5.092-9.289-10.03-19.748-13.236-27.285 c-1.194-2.811-3.537-4.975-6.436-5.943c-2.896-0.968-6.069-0.649-8.713,0.879c-12.648,7.303-48.57,10.024-68.241,10.024 c-19.672,0-55.594-2.721-68.242-10.024c-2.686-1.55-5.911-1.856-8.838-0.837c-2.928,1.018-5.268,3.26-6.411,6.141 c-3.294,8.3-8.094,19.014-12.978,28.404C157.872,118.86,157.376,104.491,160.231,94.936z M167.619,181.161 c-0.527-3.207-1.281-7.139-2.155-11.692c-0.267-1.389-0.551-2.872-0.844-4.418c9.103-10.903,18.229-30.116,23.544-42.351 c24.561,7.906,62.883,8.169,67.837,8.169c4.97,0,43.526-0.267,68.079-8.248c5.413,11.68,14.615,29.939,23.663,40.536 c-0.425,2.252-0.831,4.378-1.207,6.33c-0.87,4.544-1.625,8.469-2.153,11.672c-7.649,46.472-11.944,49.205-32.588,62.334 c-3.436,2.185-7.317,4.653-11.645,7.579c-14.681,8.415-29.534,12.68-44.153,12.68c-14.618,0-29.469-4.265-44.145-12.676 c-4.326-2.925-8.206-5.395-11.64-7.578C179.568,230.368,175.272,227.635,167.619,181.161z M175.452,294.532l15.87,47.359 c0.004,0.015,0.01,0.029,0.015,0.044l24.425,72.892c0.006,0.021,0.014,0.042,0.021,0.063l25.391,75.773l-126.289-0.001v-41.308 c0-5.892-4.776-10.667-10.667-10.667c-5.892,0-10.667,4.776-10.667,10.667v41.308H24.257 C56.023,361.779,71.563,335.532,175.452,294.532z M331.268,490.663l11.13-18.773l11.13,18.773H331.268z M418.45,490.662v-37.001 c0-5.892-4.776-10.667-10.667-10.667c-5.892,0-10.667,4.776-10.667,10.667v37.002h-18.782l-26.758-45.13 c-1.921-3.241-5.408-5.227-9.176-5.227c-3.767,0-7.255,1.986-9.176,5.227l-26.756,45.13h-35.64l25.377-75.735 c0.015-0.044,0.031-0.086,0.044-0.13l24.419-72.867c0.004-0.011,0.006-0.021,0.011-0.033l2.313-6.903 c11.059,4.312,22.823,9.114,34.203,14.677c1.508,0.737,3.104,1.086,4.678,1.086c3.946,0,7.742-2.201,9.59-5.986 c2.588-5.293,0.394-11.682-4.901-14.268c-12.436-6.079-25.042-11.194-36.784-15.76l6.774-20.213 c103.892,41,119.43,67.247,151.196,196.13L418.45,490.662z'
                              ></path>{" "}
                              <path
                                style={{ fill: "#000003" }}
                                d='M220.724,180.815c5.875,0,10.666-4.794,10.666-10.669c0-5.877-4.792-10.669-10.666-10.669 c-5.875,0-10.669,4.792-10.669,10.669C210.056,176.021,214.85,180.815,220.724,180.815z'
                              ></path>{" "}
                              <path
                                style={{ fill: "#000003" }}
                                d='M291.28,180.815c5.874,0,10.667-4.794,10.667-10.669c0-5.877-4.794-10.669-10.667-10.669 c-5.876,0-10.667,4.792-10.667,10.669C280.612,176.021,285.404,180.815,291.28,180.815z'
                              ></path>{" "}
                              <path
                                style={{ fill: "#000003" }}
                                d='M225.974,228.887c8.022,8.021,18.686,12.439,30.028,12.439c11.341,0,22.004-4.417,30.026-12.438 c4.165-4.166,4.167-10.92,0-15.086c-4.165-4.166-10.919-4.166-15.087-0.001c-3.992,3.992-9.297,6.19-14.939,6.19 c-5.643,0-10.95-2.199-14.942-6.189c-4.165-4.166-10.919-4.166-15.087,0C221.809,217.967,221.809,224.721,225.974,228.887z'
                              ></path>{" "}
                            </g>{" "}
                          </g>
                        </svg>
                        <p
                          style={{
                            marginLeft: 60,
                            marginTop: -50,
                            fontWeight: "bold",
                            fontSize: "25px",
                          }}
                        >
                          Representante legal:
                        </p>
                        <p style={{ marginLeft: 65 }}>
                          Fernando Bonifacio Morales
                          <CheckCircleIcon sx={{ color: "green" }} />
                        </p>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Typography variant='body1'>
                        <svg
                          viewBox='0 0 512 512'
                          xmlns='http://www.w3.org/2000/svg'
                          aria-hidden='true'
                          role='img'
                          class='iconify iconify--fxemoji'
                          preserveAspectRatio='xMidYMid meet'
                          fill='#000000'
                          width='40px'
                        >
                          <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                          <g
                            id='SVGRepo_tracerCarrier'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></g>
                          <g id='SVGRepo_iconCarrier'>
                            <path
                              fill='#EAC083'
                              d='M446.067 512h-217.97c-2.818 0-5.102-3.663-5.102-8.182V8.182c0-4.519 2.284-8.182 5.102-8.182H446.23c2.727 0 4.938 3.546 4.938 7.92v495.898c.001 4.519-2.283 8.182-5.101 8.182z'
                            ></path>
                            <path
                              fill='#F9E7C0'
                              d='M392.753 512H191.967L35.007 355.04V8.182A8.182 8.182 0 0 1 43.189 0h349.826a7.92 7.92 0 0 1 7.92 7.92v495.898a8.182 8.182 0 0 1-8.182 8.182z'
                            ></path>
                            <path
                              fill='#597B91'
                              d='M303.694 456.668h-60.108c-6.147 0-11.13-4.983-11.13-11.13s4.983-11.13 11.13-11.13h60.108c6.146 0 11.13 4.983 11.13 11.13s-4.983 11.13-11.13 11.13zm59.646-83.983c0-6.146-4.983-11.13-11.13-11.13H243.586c-6.147 0-11.13 4.983-11.13 11.13s4.983 11.13 11.13 11.13H352.21c6.146-.001 11.13-4.984 11.13-11.13zm-23.867-72.854c0-6.146-4.983-11.13-11.13-11.13h-84.757c-6.147 0-11.13 4.983-11.13 11.13s4.983 11.13 11.13 11.13h84.757c6.146 0 11.13-4.983 11.13-11.13zm-49.297-72.853c0-6.147-4.983-11.13-11.13-11.13H102.809c-6.147 0-11.13 4.983-11.13 11.13s4.983 11.13 11.13 11.13h176.237c6.146-.001 11.13-4.983 11.13-11.13zm-92.007 72.853c0-6.146-4.983-11.13-11.13-11.13h-84.231c-6.147 0-11.13 4.983-11.13 11.13s4.983 11.13 11.13 11.13h84.231c6.148 0 11.13-4.983 11.13-11.13zm110.859-145.707c0-6.147-4.983-11.13-11.13-11.13h-195.09c-6.147 0-11.13 4.983-11.13 11.13s4.983 11.13 11.13 11.13h195.09c6.147 0 11.13-4.983 11.13-11.13zm54.312-72.853c0-6.147-4.983-11.13-11.13-11.13H102.809c-6.147 0-11.13 4.983-11.13 11.13s4.983 11.13 11.13 11.13H352.21c6.146 0 11.13-4.983 11.13-11.13z'
                            ></path>
                            <path
                              fill='#EAC083'
                              d='M191.967 512L35.007 355.04h123.597c18.426 0 33.363 14.937 33.363 33.363V512z'
                            ></path>
                          </g>
                        </svg>
                        <p
                          style={{
                            marginLeft: 60,
                            marginTop: -50,
                            fontWeight: "bold",
                            fontSize: "25px",
                          }}
                        >
                          Datos Fiscales{" "}
                          <ErrorOutlineIcon sx={{ color: "orange" }} />
                        </p>
                        <p style={{ marginLeft: 65 }}>
                          Los datos que ocupamos para calcular impuestos y
                          emitir facturas
                        </p>
                      </Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <Typography variant='body1'>
                        <svg
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                          width='25px'
                        >
                          <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                          <g
                            id='SVGRepo_tracerCarrier'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></g>
                          <g id='SVGRepo_iconCarrier'>
                            {" "}
                            <path
                              d='M12 6H12.01M9 20L3 17V4L5 5M9 20L15 17M9 20V14M15 17L21 20V7L19 6M15 17V14M15 6.2C15 7.96731 13.5 9.4 12 11C10.5 9.4 9 7.96731 9 6.2C9 4.43269 10.3431 3 12 3C13.6569 3 15 4.43269 15 6.2Z'
                              stroke='#000000'
                              strokeWidth='2'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                            ></path>{" "}
                          </g>
                        </svg>
                        <p>{contactInfo.address}</p>
                      </Typography>
                    </Grid> */}
                    {/* <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <Typography variant='body1'>
                        <svg
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                          width='25px'
                        >
                          <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                          <g
                            id='SVGRepo_tracerCarrier'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></g>
                          <g id='SVGRepo_iconCarrier'>
                            {" "}
                            <path
                              d='M12 14.0709C11.6734 14.0242 11.3395 14 11 14C7.13401 14 4 17.134 4 21H14M17.997 18C18.997 17 19.997 16.6046 19.997 15.5C19.997 14.3954 19.1016 13.5 17.997 13.5C17.0651 13.5 16.282 14.1374 16.06 15M17.997 21H18.007M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z'
                              stroke='#000000'
                              strokeWidth='2'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                            ></path>{" "}
                          </g>
                        </svg>
                        <p>{contactInfo.typeUser}</p>
                      </Typography>
                    </Grid> */}
                    {/* <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <Typography variant='body1'>
                        <svg
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                          width='25px'
                        >
                          <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
                          <g
                            id='SVGRepo_tracerCarrier'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          ></g>
                          <g id='SVGRepo_iconCarrier'>
                            {" "}
                            <path
                              d='M12 17V11'
                              stroke='#1C274C'
                              strokeWidth='1.5'
                              strokeLinecap='round'
                            ></path>{" "}
                            <circle
                              cx='1'
                              cy='1'
                              r='1'
                              transform='matrix(1 0 0 -1 11 9)'
                              fill='#1C274C'
                            ></circle>{" "}
                            <path
                              d='M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C21.5093 4.43821 21.8356 5.80655 21.9449 8'
                              stroke='#1C274C'
                              strokeWidth='1.5'
                              strokeLinecap='round'
                            ></path>{" "}
                          </g>
                        </svg>
                        <p>{contactInfo.extras}</p>
                      </Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Button
                        variant='contained'
                        color='primary'
                        onClick={handleEditClick}
                        style={{ marginTop: "20px" }}
                      >
                        Editar
                      </Button>
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Layout>
  );
};

export default CompanyInformation;
